import React, { useEffect, useState } from 'react';
import { Layout, Typography, Dropdown, message } from 'antd';

import logo from '../../../images/sleasing-logo-primary 1.svg';
import userLogo from '../../../images/Setting.svg';
import { DownOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { Header } = Layout;
const Navigation = ({ user, actions }) => {
  const [role, setRole] = useState(null);
  useEffect(() => {
    const result = getRole(user?.role);
    setRole(result);
  }, [user]);

  const getRole = type => {
    switch (type) {
      case 'Leasing admin':
        return 'Leasing Admin';
      case 'Leasing korisnik':
        return 'Leasing Korisnik';
      case 'Dobavljač admin':
        return 'Dobavljač Admin';
      case 'Dobavljač korisnik':
        return 'Dobavljač Korisnik';
    }
  };

  const onClick = ({ key }) => {
    if (key === 'odjava') {
      actions.logoutUser();
    }
  };

  const items = [
    {
      label: 'Odjavi se',
      key: 'odjava',
    },
  ];

  return (
    <div>
      <Layout>
        <Header className="flex items-center justify-between h-24">
          <img className="h-12" src={logo} />
          {/* <div className="flex items-center justify-between"> */}
          <Dropdown
            trigger={['click']}
            menu={{
              items,
              onClick,
            }}
          >
            <a className="flex items-center" onClick={e => e.preventDefault()}>
              <img src={userLogo} />

              <Title className="text-white text-sm font-normal pt-2 ml-2 mr-3">
                {role && role}
              </Title>
              <DownOutlined className="text-[#F2F2F2]" />
            </a>
          </Dropdown>
          {/* </div> */}
        </Header>
      </Layout>
    </div>
  );
};

export default Navigation;
